function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 12,
    height: 11.40000057220459,
    viewBox: "0 0 12 11.40000057220459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.2,10.2L10.8,10.2L10.8,6L12,6L12,10.8C12,11.1314,11.7314,11.4,11.4,11.4L0.6,11.4C0.268629,11.4,0,11.1314,0,10.8L0,6L1.2,6L1.2,10.2ZM7.2,4.2L7.2,7.8L4.8,7.8L4.8,4.2L1.8,4.2L6,0L10.2,4.2L7.2,4.2Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadBlob);
export default __webpack_public_path__ + "static/media/upload_blob.7d32f4c852f9f8f1496b298acd827227.svg";
export { ForwardRef as ReactComponent };